'use client';

import EmailsPage from '@/views/products/emails';

export default EmailsPage;
